import List from "@/components/list";
import vue from "@/main";

const Table = (args) => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function noop() {};

  const beforeDelete = (row, idx) => {
    vue
      .$msgbox({
        message: "您确认要删除该分区吗",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then((res) => {
        listeners.delete && listeners.delete(row, idx);
      })
      .catch((_) => _);
  };

  const Deal = ({ props: { vo } }) => {
    const user = vo.row;
    const dealConf = [];
    const { row } = vo;
    dealConf.push(
      [
        row.onlineStatusName && row.onlineStatus === 0
          ? "icon-edit"
          : "icon-edit-disable",
        "编辑",
        () => {
          if (row.onlineStatus !== 0) return;
          listeners.edit && listeners.edit(vo.row, vo.$index);
        },
        "region:update",
      ],
      [
        row.onlineStatusName && row.onlineStatus === 0
          ? "icon-delete"
          : "icon-delete-disable",
        "删除",
        () => {
          if (row.onlineStatus !== 0) return;
          beforeDelete(vo.row, vo.$index);
        },
        "region:delete",
      ]
    );
    if(row.onlineStatusName && row.onlineStatus === 0){
      dealConf.push(
        [ 
          "icon-up",
          "上线",
          () => {
            listeners.line && listeners.line(vo.row, vo.$index);
          },
          "region:online",
        ]
      )  
    }else(
      dealConf.push(
        [ 
          "icon-down",
          "下线",
          () => {
            listeners.line && listeners.line(vo.row, vo.$index);
          },
          "region:online",
        ]
      )  
    )
    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    // {
    //   type: "selection",
    //   label: "main"
    // },
    {
      label: "专区名称",
      prop: "regionTitle",
      minWidth: "200",
      showOverflowTooltip: true,
    },
    {
      label: "展示版式",
      prop: "showTypeName",
      minWidth: "110",
      showOverflowTooltip: true,
    },
    {
      label: "展示数量",
      prop: "showNum",
      minWidth: "100",
      showOverflowTooltip: true,
    },
    {
      label: "状态",
      prop: "onlineStatusName",
      minWidth: "100",
    },
    {
      label: "创建者",
      prop: "createUserName",
      minWidth: "100",
    },
    {
      label: "创建时间",
      prop: "createDate",
      minWidth: "200",
      showOverflowTooltip: true,
    },
    {
      label: "操作",
      fixed: "right",
      minWidth: "230",
      render: (vo) => <Deal vo={vo} />,
    },
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
